import React, {useState} from 'react';

import {ActionsButton} from 'app/general/widgets/ActionsButton';
import {useBulkRevokeTasks} from 'app/tasks/api';
import {gt} from 'app/utils/i18n';

import {CancelTaskModal} from './CancelTaskModal';

import {SlimTaskInstanceSerializedType} from 'sweet-types';

interface Props {
  tasks: Array<SlimTaskInstanceSerializedType>;
  enableBulkSelect: boolean;
}

export function TaskBulkActionsButton({
  tasks,
  enableBulkSelect,
}: Props): JSX.Element | null {
  if (!enableBulkSelect) {
    return null;
  }

  const [bulkRevokeTasksAccess] = useBulkRevokeTasks();

  const [show, setShow] = useState<'cancel' | null>(null);

  const availableActions = [
    {
      text: gt('Cancel tasks (%s selected)', tasks.length),
      key: 'cancel',
      icon: 'fa fa-times',
      disabled:
        !tasks.every((task) => task.template.can_assign) || tasks.length === 0,
      callback: () => setShow('cancel'),
    },
    {
      text: gt('Revoke access to tasks (%s selected)', tasks.length),
      key: 'revoke',
      icon: 'fa fa-times',
      disabled:
        !tasks.every((task) => task.template.can_revoke) || tasks.length === 0,
      callback: () =>
        bulkRevokeTasksAccess({tasks: tasks.map((task) => task.template.url)}),
    },
  ];

  return (
    <div className="d-flex justify-content-center">
      <ActionsButton actions={availableActions} />
      <CancelTaskModal
        show={show === 'cancel'}
        tasks={tasks}
        close={() => setShow(null)}
        onClosed={() => null}
      />
    </div>
  );
}
